<template>
	<span v-if="typeV=='money'">{{valueFilter(valueDec,valueDecComplement)}}</span>
	<span v-else-if="typeV=='num'">{{valueFilter(valueNumDec,valueNumDecComplement)}}</span>
	<span v-else-if="typeV=='discount'">{{valueFilter(valueDiscountDec,valueDiscountDecComplement)}}</span>
	<span v-else-if="typeV=='price'">{{valueFilter(valuePriceDec,valuePriceDecComplement)}}</span>
	<span v-else-if="typeV=='packing'">{{valueFilter(valuePackingDec,valuePackingComplement)}}</span>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		props:{
			value:{
				type:[String,Number],
				default:0
			},
            typeV:{
                type:String,
				default:''
            }
		},
		computed:{
            //金额小数位==money
			valueDec(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.moneyDec)?Number(this.$store.state.sysConfig.pointConfig.moneyDec):0
			},
            //金额补零
			valueDecComplement(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.moneyDecComplement)?Number(this.$store.state.sysConfig.pointConfig.moneyDecComplement):0
			},
            //数量小数位==num
			valueNumDec(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.numDec)?Number(this.$store.state.sysConfig.pointConfig.numDec):0
			},
            //数量补零
			valueNumDecComplement(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.numDecComplement)?Number(this.$store.state.sysConfig.pointConfig.numDecComplement):0
			},
            //折扣小数位==discount
			valueDiscountDec(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.discountDec)?Number(this.$store.state.sysConfig.pointConfig.discountDec):0
			},
            //折扣补零
			valueDiscountDecComplement(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.discountDecComplement)?Number(this.$store.state.sysConfig.pointConfig.discountDecComplement):0
			},
            //单价小数位==pice
			valuePriceDec(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.priceDec)?Number(this.$store.state.sysConfig.pointConfig.priceDec):0
			},
            //单价补零
			valuePriceDecComplement(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.priceDecComplement)?Number(this.$store.state.sysConfig.pointConfig.priceDecComplement):0
			},
            //包装小数位==packing
			valuePackingDec(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.packingDec)?Number(this.$store.state.sysConfig.pointConfig.packingDec):0
			},
            //包装补零
			valuePackingComplement(){
				return !isNaN(this.$store.state.sysConfig.pointConfig.packingDecComplement)?Number(this.$store.state.sysConfig.pointConfig.packingDecComplement):0
			},
		},
		methods:{
			valueFilter(valueDec,valueDecComplement){
				let str = this.value;
				if(!isNaN(str) && str != 0 && this.valueDec != 0){
					// 是一个Number
					let liststr = String(str).split(".");
					if(valueDecComplement==0){
						// 不需要补零
						if(liststr.length==2 && liststr[1].length>valueDec){
							// 当前数据超过系统小数位
							str = Number(this.value).toFixed(valueDec)
						}
					}else{
						// 需要补零
						if(liststr.length==2 && liststr[1].length>valueDec){
							str = Number(this.value).toFixed(valueDec)
						}else if(liststr.length==2 && liststr[1].length<=valueDec){
                             
							let dotLength = valueDec - liststr[1].length;
							let zeroStr = '';
							for(let i = 0;i<dotLength;i++){
								zeroStr += '0'
							}
							str += zeroStr
						}else{
							let zeroStr = '.';
							for(let i = 0;i<valueDec;i++){
								zeroStr += '0'
							}
							str += zeroStr
						}
					}
				}
				return str
			}
		}
	}
</script>

<style>
</style>